import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrPolicyCheckComponent } from './policy-check.component';

@NgModule({
  imports: [CommonModule],
  declarations: [CrPolicyCheckComponent],
  exports: [CrPolicyCheckComponent],
})
export class CrPolicyCheckModule {}
